module.exports = __webpack_public_path__ + "img/Certificate.009b6768.jpg";